import { render } from "./GenerateBrokerCode.vue?vue&type=template&id=04a6e9ae"
import script from "./GenerateBrokerCode.vue?vue&type=script&lang=js"
export * from "./GenerateBrokerCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__